function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_badge_down_1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#ffcc00",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M24.0369594,5 L24.149513,5.00662551 C24.5924713,5.05935292 24.9439154,5.41946106 24.9953306,5.87331393 L25.0018132,5.98860653 L25.0014293,19.4203426 L27.3898027,16.9729273 C27.5572737,16.8013385 27.8172365,16.7822731 28.0052613,16.9157311 L28.0720773,16.9729273 L28.754352,17.6719777 C28.9192063,17.8408855 28.9398131,18.1016208 28.8161723,18.2934855 L28.754352,18.3710281 L24.3776883,22.855207 L24.3108682,22.9124411 C24.203213,22.9888418 24.0719812,23.0152443 23.9480343,22.991648 C23.8243821,23.0153863 23.6927328,22.9890478 23.5847874,22.9124411 L23.5179674,22.855207 L19.1413037,18.3710281 C18.9528988,18.1779907 18.9528988,17.8650151 19.1413037,17.6719777 L19.8235783,16.9729273 C20.0119833,16.7798899 20.3174481,16.7798899 20.505853,16.9729273 L22.8942264,19.4203426 L22.8938425,5.98860653 C22.8938018,5.48161367 23.2662712,5.06374687 23.7461426,5.00662551 L23.8586963,5 L23.9478278,5.005 L24.0369594,5 Z",
  id: "Path",
  fill: "#FFFFFF"
}));

const SvgIcBadgeDown1 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcBadgeDown1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_badge_down_1.da086ce5.svg";
export { ForwardRef as ReactComponent };